import { IntervalEndingEnum } from '@/services/models/enums'
import { Interval } from '@/types/variable'

export function convertIntervalsToReadableFormat(
  intervals: Array<Interval>,
  states: string[],
) {
  if (intervals.length !== states.length)
    throw new Error('Intervals and states must have the same length')
  const getBracket = (ending: IntervalEndingEnum, side: 'left' | 'right') => {
    switch (ending) {
      case IntervalEndingEnum.Open:
        return side === 'left' ? '(' : ')'
      case IntervalEndingEnum.Closed:
        return side === 'left' ? '[' : ']'
      default:
        throw new Error(`Unknown ending`)
    }
  }
  return intervals
    .map(
      (interval, index) =>
        `${states[index]}: ${getBracket(interval.lowerEnding, 'left')}${interval.lowerBound},${interval.upperBound}${getBracket(interval.upperEnding, 'right')}${index === intervals.length - 1 ? '' : ', '}`,
    )
    .join('')
}
